import { NgModule  } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { HeaderbarComponent } from 'src/app/components/headerbar/headerbar.component';
import { SpinnerComponent } from 'src/app/components/spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({ 
  
    imports: [
      IonicModule, 
      CommonModule,  
      TranslateModule.forChild()
    ],
    declarations: [
      HeaderbarComponent, 
      SpinnerComponent
    ],
    exports: [ 
      HeaderbarComponent, 
      SpinnerComponent
    ],
    entryComponents: [
      // ModalLanguagePage 
    ]
  })
  export class ComponentsModule { 
    constructor() { 
    }    
  }